import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";
import {EventsService} from '../shared/services/events.service';
import * as AOS from 'aos';
import { CommonapiService } from '../shared/services/commonapi.service';
//jquery declaration
declare var $: any;

@Component({
  selector: 'app-safetytraining',
  templateUrl: './safetytraining.component.html',
  styleUrls: ['./safetytraining.component.css']
})
export class SafetytrainingComponent implements OnInit {

  eventDetails:any=[];
  event:any=null;
  name: string = "";  
  phone: string = "";
  email: string = "";

  constructor(
    private service:EventsService,
    private titleService: Title,
    private commonApiService: CommonapiService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle("Safety Training - SFI Compliance, Inc");
    AOS.init();
    await this.service.getEvents().then(data=>{      
      this.eventDetails=data;      
    })
    console.log(this.event);
  }

  getData(_dt){    
    this.event=_dt;
    console.log(this.event);

  }
  ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return (true)
    }
    return (false)
  }

  async submitData(){
    if (this.name === "") {
      alert("Please Enter Your Name");
      document.getElementById("name").focus();
      return;
    }
    else if (this.email === "") {
      alert("Please Enter Your Email Address");
      document.getElementById("email").focus();
      return;
    }
    else if (this.email !== "" && this.ValidateEmail(this.email) === false) {
      alert("Please Enter Valid Email Address");
      document.getElementById("email").focus();
      return;
    }
    // else if (this.phone === "") {
    //   alert("Please Enter Your Phone Number");
    //   document.getElementById("phone").focus();
    //   return;
    // }   

    const _obj = {
      Mode: "ADD",
      MemberId:0,
      EventId:this.event.id,
      EventName:this.event.eventname,
      MemberName:this.name,
      EmailId:this.email,
      ContactNo:this.phone===""?"":this.phone,
      IsAdded:false,
      IsActive:true
    };
    
    let _dt = await this.commonApiService.postData("/api/MarketingController/DBEventAddMember", _obj).toPromise();

    console.log(_dt);

    if (_dt && _dt[0].DataSet) {
      alert(_dt[0].DataSet.Message);
      
        this.name = "";        
        this.phone = "";
        this.email = "";
        this.event=null;

        $('#exampleModal').modal('hide')
    }
  }
  

}
